const CHAINS = [
  { value: 'luna', label: 'Luna', chainID: 'phoenix-1' },
  { value: 'lunc', label: 'Lunc', chainID: 'columbus-5' }
];

export default CHAINS;
